// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.evolution-g6-container {
  background: #fafbfc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.evolution-g6-canvas {
  width: 100%;
  height: 100%;
}

/* ── Toolbar button group (matches SubTableView style) ── */
.evolution-toolbar-btn {
  background: rgba(255,255,255,0.12) !important;
  border: 1px solid rgba(255,255,255,0.45) !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  padding: 6px 14px !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  backdrop-filter: blur(4px) !important;
  transition: all 0.2s ease !important;
  box-shadow: none !important;
}

.evolution-toolbar-btn:hover {
  background: rgba(255,255,255,0.22) !important;
  border-color: rgba(255,255,255,0.7) !important;
  box-shadow: 0 2px 12px rgba(255,255,255,0.15) !important;
}

.evolution-toolbar-btn:active {
  background: rgba(255,255,255,0.28) !important;
}
`, "",{"version":3,"sources":["webpack://./src/scene-pm/Projects/ProjectView/EvolutionView/EvolutionViewG6.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,4DAA4D;AAC5D;EACE,6CAA6C;EAC7C,mDAAmD;EACnD,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,wDAAwD;AAC1D;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":[".evolution-g6-container {\n  background: #fafbfc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n}\n\n.evolution-g6-canvas {\n  width: 100%;\n  height: 100%;\n}\n\n/* ── Toolbar button group (matches SubTableView style) ── */\n.evolution-toolbar-btn {\n  background: rgba(255,255,255,0.12) !important;\n  border: 1px solid rgba(255,255,255,0.45) !important;\n  color: #ffffff !important;\n  border-radius: 8px !important;\n  padding: 6px 14px !important;\n  font-weight: 500 !important;\n  font-size: 13px !important;\n  backdrop-filter: blur(4px) !important;\n  transition: all 0.2s ease !important;\n  box-shadow: none !important;\n}\n\n.evolution-toolbar-btn:hover {\n  background: rgba(255,255,255,0.22) !important;\n  border-color: rgba(255,255,255,0.7) !important;\n  box-shadow: 0 2px 12px rgba(255,255,255,0.15) !important;\n}\n\n.evolution-toolbar-btn:active {\n  background: rgba(255,255,255,0.28) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
